import { Image } from 'react-native'

const Images = {
  tick: Image.resolveAssetSource(require('./../Images/Icons/HIFI/tick.png')),
  spotify: Image.resolveAssetSource(require('./../Images/Icons/HIFI/Spotify.png')),
  netflix: Image.resolveAssetSource(require('./../Images/Icons/HIFI/Netflix.png')),
  modem: Image.resolveAssetSource(require('./../Images/Icons/HIFI/modem.png')),

  bundles: Image.resolveAssetSource(require('./../Images/Icons/Icons/bundles.png')),
  details: Image.resolveAssetSource(require('./../Images/Icons/Icons/details.png')),
  contract: Image.resolveAssetSource(require('./../Images/Icons/Icons/contract.png')),
  roaming: Image.resolveAssetSource(require('./../Images/Icons/Icons/roaming.png')),
  vcoin: Image.resolveAssetSource(require('./../Images/Icons/Icons/vcoin.png')),
  smsText: Image.resolveAssetSource(require('./../Images/Icons/Icons/sms_text.png')),
  landline: Image.resolveAssetSource(require('./../Images/Icons/Icons/landline.png')),
  dataSharing: Image.resolveAssetSource(require('./../Images/Icons/Icons/data_sharing.png')),
  deliveryAddress: Image.resolveAssetSource(require('./../Images/Icons/Icons/deliveryAddress.png')),
  deliveryAddressWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/deliveryAddressWhite.png')),

  idIcon: Image.resolveAssetSource(require('./../Images/Icons/Icons/idIcon.png')),
  close: Image.resolveAssetSource(require('./../Images/Icons/Icons/close.png')),
  close_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/closeWhite.png')),
  tv_hi_mid: Image.resolveAssetSource(require('./../Images/Icons/Icons/tv-hi-mid.png')),
  tv_hi_mid_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/tv-hi-mid-white.png')),
  ic_chevron_up: Image.resolveAssetSource(require('./../Images/Icons/Icons/ic_chevron_up.png')),
  ic_chevron_down: Image.resolveAssetSource(require('./../Images/Icons/Icons/ic_chevron_down.png')),
  marker: Image.resolveAssetSource(require('./../Images/Icons/Icons/marker.png')),
  searchIcon: Image.resolveAssetSource(require('./../Images/Icons/Icons/search.png')),
  indicator: Image.resolveAssetSource(require('./../Images/Icons/Icons/indicator.png')),
  info: Image.resolveAssetSource(require('./../Images/Icons/Icons/info_circle.png')),
  warning: Image.resolveAssetSource(require('../Images/Icons/HIFI/warning.png')),

  upload: Image.resolveAssetSource(require('./../Images/Icons/Icons/upload.png')),
  wifi: Image.resolveAssetSource(require('./../Images/Icons/Icons/wifi.png')),
  tvRed: Image.resolveAssetSource(require('./../Images/Icons/Icons/tvRed.png')),
  tvGrey: Image.resolveAssetSource(require('./../Images/Icons/Icons/tvGrey.png')),
  tvWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/tvWhite.png')),
  document: Image.resolveAssetSource(require('./../Images/Icons/Icons/document.png')),
  internetGrey: Image.resolveAssetSource(require('./../Images/Icons/Icons/internetGrey.png')),

  cameraBackground: Image.resolveAssetSource(require('./../Images/Icons/HIFI/cameraBackground.png')),
  flash_filled: Image.resolveAssetSource(require('./../Images/Icons/Icons/flash_filled.png')),
  flash: Image.resolveAssetSource(require('./../Images/Icons/Icons/flash.png')),
  close_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/closeWhite.png')),

  ic_bundles_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/ic_bundles_white.png')),
  internet_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/internet_white.png')),
  upload_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/upload_white.png')),
  document_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/document_white.png')),
  wifi_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/wifi_white.png')),
  idIcon_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/idIcon_white.png')),
}

export default Images
